import React from 'react'

function ImpressumModal({ isOpen, onClose }) {
  if (!isOpen) return null

  return (
    <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Impressum</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p><strong>Angaben gemäß § 5 TMG:</strong></p>
            <p>
              Thomas Andersen<br />
              Marchlewskistraße 61<br />
              1243, Berlin, Germany
            </p>

            <p><strong>Kontakt:</strong><br />
              E-Mail: support@faqhelper.io
            </p>

            {/* <p><strong>Vertreten durch:</strong><br />
              [Name of legal representative]
            </p> */}

            {/* <p><strong>Umsatzsteuer-ID:</strong><br />
              [DE123456789 if applicable]
            </p> */}

            <h5>Haftung für Inhalte</h5>
            <p>Wir sind für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.</p>

            <h5>Haftung für Links</h5>
            <p>Wir übernehmen keine Haftung für Inhalte externer Links.</p>

            <h5>Urheberrecht</h5>
            <p>Alle Inhalte auf dieser Website unterliegen dem deutschen Urheberrecht.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImpressumModal
